import { render } from "./HistoricalDataVisualization.vue?vue&type=template&id=327b9cc7"
import script from "./HistoricalDataVisualization.vue?vue&type=script&lang=js"
export * from "./HistoricalDataVisualization.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__